import { useState, useEffect } from "react";
import "../styles/GallerySerene.css";

import Img1 from "../assets/palms-images/1.avif";
import Img2 from "../assets/palms-images/2.avif";
import Img3 from "../assets/palms-images/3.avif";
import Img4 from "../assets/palms-images/4.avif";
import Img5 from "../assets/palms-images/5.avif";
import Img6 from "../assets/palms-images/6.avif";
import Img7 from "../assets/palms-images/7.avif";
import Img8 from "../assets/palms-images/8.avif";
import Img9 from "../assets/palms-images/9.avif";

// Ensure we have exactly 9 images for the 3x3 grid
const images = [
    { src: Img2, label: "Entrance Revised" },
    { src: Img3, label: "Covered Seating" },
    { src: Img4, label: "Double-Height Spaces" },
    { src: Img5, label: "Half Basketball Court" },
    { src: Img6, label: "Kids’ Play Area" },
    { src: Img7, label: "Open Space Lawn" },
    { src: Img8, label: "Open Spaces – Play Court" },
    { src: Img9, label: "Rock Garden Seating" },
    { src: Img1, label: "Sheet Fall Feature" },
];

export default function GalleryPalms() {
    const [activeIndex, setActiveIndex] = useState(0);
    const [isHovering, setIsHovering] = useState(false);
    const activeImage = images[activeIndex];

    const handlePrev = () => {
        setIsHovering(false);
        setActiveIndex((prev) => (prev - 1 + images.length) % images.length);
    };

    const handleNext = () => {
        setIsHovering(false);
        setActiveIndex((prev) => (prev + 1) % images.length);
    };

    // Auto-rotate background if not hovering
    useEffect(() => {
        if (isHovering) return; // Pause auto-play on hover

        const interval = setInterval(() => {
            setActiveIndex((prev) => (prev + 1) % images.length);
        }, 5000);

        return () => clearInterval(interval);
    }, [isHovering]);

    return (
        <section className="gallery-section" id="palms-gallery">
            {/* Full Screen Backgrounds */}
            <div className="gallery-background">
                {images.map((img, index) => (
                    <img
                        key={index}
                        src={img.src}
                        alt={img.label}
                        className={`bg-image ${index === activeIndex ? "active" : ""}`}
                    />
                ))}
                <div className="gallery-overlay"></div>
            </div>

            {/* Foreground Content */}
            <div className="gallery-content">
                <div className="gallery-grid">
                    {images.map((img, index) => (
                        <div
                            key={index}
                            className="grid-item"
                            onMouseEnter={() => {
                                setActiveIndex(index);
                                setIsHovering(true);
                            }}
                            onMouseLeave={() => setIsHovering(false)}
                        >
                            <div className="grid-content text-center">
                                <span>{img.label}</span>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="gallery-carousel">
                    <button
                        type="button"
                        className="carousel-control prev"
                        onClick={handlePrev}
                        aria-label="Previous image"
                    >
                        &#8249;
                    </button>

                    <div className="carousel-slide">
                        <img
                            src={activeImage.src}
                            alt={activeImage.label}
                            className="carousel-image"
                        />
                        <div className="carousel-caption">{activeImage.label}</div>
                    </div>

                    <button
                        type="button"
                        className="carousel-control next"
                        onClick={handleNext}
                        aria-label="Next image"
                    >
                        &#8250;
                    </button>
                </div>

                <div className="carousel-dots">
                    {images.map((img, index) => (
                        <button
                            type="button"
                            key={img.label}
                            className={`carousel-dot ${index === activeIndex ? "active" : ""}`}
                            onClick={() => {
                                setIsHovering(false);
                                setActiveIndex(index);
                            }}
                            aria-label={`Go to ${img.label}`}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}
